module.exports = __webpack_public_path__ + "img/book-12.00b5b701.png";